import { defineAction } from '~/prix'
import { z } from 'zod'
import actionJson from './waterSourceDocumentUpdate.action.json' with { type: 'json' }
import { waterSourceDocumentUpdateInputObject } from '../waterSourceDocumentObject'

const definition = defineAction({
  ...actionJson,
  input: waterSourceDocumentUpdateInputObject,
  output: z.object({}),
})

export default definition
